// extracted by mini-css-extract-plugin
module.exports = {"spin":"spinner_spin__Bw7h9"};